import React from "react";
import { Tab } from "../tabbedSection/TabbedSection";
import RegistrationAndAttendance from "./RegistrationAndAttendance";
import CampsitesAndVisitation from "./CampsitesAndVisitation";
import DressCode from "./DressCode";
import WhatToLeave from "./WhatToLeave";
import FridayAndSaturday from "./FridayAndSaturday";
import VolunteerWork from "./VolunteerWork";
import Visitors from "./Visitors";
import Schedule from "./Schedule";

const getContent = (selectedSection: Tab) => {
  if (selectedSection === Tab.REGISTRATION_AND_ATTENDANCE) {
    return <RegistrationAndAttendance />;
  }
  if (selectedSection === Tab.CAMPSITES_AND_VISITATION) {
    return <CampsitesAndVisitation />;
  }
  if (selectedSection === Tab.DRESS_CODE) {
    return <DressCode />;
  }
  if (selectedSection === Tab.WHAT_TO_LEAVE) {
    return <WhatToLeave />;
  }
  if (selectedSection === Tab.FRIDAY_AND_SATURDAY) {
    return <FridayAndSaturday />;
  }
  if (selectedSection === Tab.VOLUNTEER_WORK) {
    return <VolunteerWork />;
  }
  if (selectedSection === Tab.VISITORS) {
    return <Visitors />;
  }
  return <Schedule />;
};

interface SectionsProps {
  selectedSection: Tab;
}

function Sections({ selectedSection }: SectionsProps) {
  return (
    <div
      style={{
        margin: "5px 5px 25px 0",
        padding: "10px 5px 5px 10px",
        backgroundColor: "white",
        height: "100%",
      }}
    >
      {getContent(selectedSection)}
    </div>
  );
}

export default Sections;
